/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { StyledTrack } from './styles';

function Track(props: any, state: any) {
  return (
    <StyledTrack {...props} index={state.index} />
  );
}

export default Track;
